import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    bonusReportKey,
    dmiLessonsKey,
    dmiProductKey,
    scannerKey,
    spotlightVideosKey,
    tradeAlertKey,
    webinarKey
} from "@/types/products/product-definitions";

// Non-reactive variables
import {
    configureProductActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = tradeAlertKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: dmiProductKey
}

const productActionTopicKeys = [
    bonusReportKey,
    scannerKey,
    tradeAlertKey,
    spotlightVideosKey,
    webinarKey,
    dmiLessonsKey
];

export function useDarkMoneyIndicator() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( dmiProductKey, productActionTopicKeys );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        selectedView
    }
}
